import React, { createContext, useContext, useEffect, useState } from "react";
import io from "socket.io-client";

const SocketContext = createContext();

export const useSocket = () => {
  const context = useContext(SocketContext);
  if (!context) {
    throw new Error("useSocket must be used within a SocketProvider");
  }
  return context;
};

export const SocketProvider = ({ children }) => {
  const [socket, setSocket] = useState(null);
  const [connected, setConnected] = useState(false);

  useEffect(() => {
    // Initialize socket connection
    const newSocket = io(
      process.env.REACT_APP_BACKEND_URL || "http://localhost:5000",
      {
        transports: ["websocket", "polling"],
        withCredentials: true,
      }
    );

    newSocket.on("connect", () => {
      console.log("Socket connected:", newSocket.id);
      setConnected(true);
    });

    newSocket.on("disconnect", () => {
      console.log("Socket disconnected:", newSocket.id);
      setConnected(false);
    });

    newSocket.on("connect_error", (error) => {
      console.error("Socket connection error:", error);
      setConnected(false);
    });

    setSocket(newSocket);

    return () => {
      newSocket.close();
    };
  }, []);

  const joinAnimeRoom = (animeId) => {
    if (socket && connected) {
      socket.emit("joinAnime", animeId);
    }
  };

  const leaveAnimeRoom = (animeId) => {
    if (socket && connected) {
      socket.emit("leaveAnime", animeId);
    }
  };

  const joinProfileRoom = (uid) => {
    if (socket && connected && uid) {
      socket.emit("joinProfile", uid);
    }
  };

  const leaveProfileRoom = (uid) => {
    if (socket && connected && uid) {
      socket.emit("leaveProfile", uid);
    }
  };

  const emitTyping = (animeId, userId, username, isTyping) => {
    if (socket && connected) {
      socket.emit("typing", {
        animeId,
        userId,
        username,
        isTyping,
      });
    }
  };

  const value = {
    socket,
    connected,
    joinAnimeRoom,
    leaveAnimeRoom,
    emitTyping,
    joinProfileRoom,
    leaveProfileRoom,
  };

  return (
    <SocketContext.Provider value={value}>{children}</SocketContext.Provider>
  );
};
